module.exports = "/_next/static/images/black-clear-dots-9dfca4845bc108c74d8201842c7d64cb.png";